import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import type { ContactOrderPreconfigurationReasonCounts } from "../_shared/_logic/preconfiguration"

export type PreconfigurationApplyFeedback = {
  total: number
  applied: number
  skipped?: number
  reason?: string
  reasonCounts?: ContactOrderPreconfigurationReasonCounts
}

const reasonLabels: Record<keyof ContactOrderPreconfigurationReasonCounts, string> = {
  email_unavailable: "E-Mail nicht verfügbar",
  mobile_message_unavailable: "Mobile Nachricht nicht verfügbar",
  phone_unavailable: "Automatischer Anruf nicht verfügbar",
  digital_unavailable: "Automatische Kontaktwegeauswahl nicht verfügbar",
  postal_unavailable: "Gewählte Briefzustellung nicht verfügbar",
}

const clampCount = (value: number) => Math.max(0, Math.floor(Number.isFinite(value) ? value : 0))

export const notifyPreconfigurationApplyResult = ({
  total,
  applied,
  skipped,
  reason,
  reasonCounts,
}: PreconfigurationApplyFeedback) => {
  const safeTotal = clampCount(total)

  if (safeTotal <= 0) return

  const safeApplied = Math.min(clampCount(applied), safeTotal)
  const safeSkipped =
    skipped === undefined ? safeTotal - safeApplied : Math.min(clampCount(skipped), safeTotal)

  if (safeSkipped <= 0) return

  const countedReasons = Object.entries(reasonLabels)
    .map(([key, label]) => {
      const count = clampCount(
        reasonCounts?.[key as keyof ContactOrderPreconfigurationReasonCounts] ?? 0,
      )

      return count ? `${label}: ${count}` : null
    })
    .filter(Boolean)
  const reasonText = countedReasons.length
    ? ` ${countedReasons.join("; ")}. Die betroffenen Zeilen bleiben vollständig unverändert.`
    : reason?.trim()
      ? ` ${reason.trim()}`
      : ""
  newNotification({
    class: "warning",
    html: `Vorkonfiguration konnte bei ${safeSkipped} von ${safeTotal} Zeilen nicht angewandt werden.${reasonText}`,
  })
}
